const mandatoryColumns = {
    ItemCategoryTitle: "ItemCategoryTitle",
};

export { mandatoryColumns };
